import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import '@gatecheckpro/design-system/tokens.css';
import '@gatecheckpro/design-system/base.css';
import { App } from './App.tsx';
import { SessionProvider } from './lib/session.tsx';
import { ErrorBoundary } from './lib/ErrorBoundary.tsx';

const container = document.getElementById('root');
if (container === null) throw new Error('Root container is missing');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/*
        The backstop. The boundary inside the workspace keeps the shell alive
        for anything that fails within a page; this one catches what fails
        above it — the session provider, the router, the shell itself — where
        there is no navigation left to preserve and reloading is the only
        honest offer.
      */}
      <ErrorBoundary what="The workspace">
        <SessionProvider>
          <App />
        </SessionProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
